// Dependencies imports
import React, { useState } from 'react';
import { DataGrid, GridToolbarContainer, GridToolbar } from '@material-ui/data-grid';
import Checkbox from "@material-ui/core/Checkbox";
import { awsSignIn, authData } from "../../redux/auth/authSlice";
import Skeleton from "@material-ui/lab/Skeleton";
import swal from 'sweetalert';
import { makeStyles } from '@material-ui/styles';

// Local imports
import { ReactComponent as Search } from '../../assets/svg/search_black_24dp.svg';
import { ReactComponent as Download } from '../../assets/svg/file_download_black_24dp.svg';

// Styles imports
import Assesg from './AttendanceGrid.module.scss';
import { useSelector, useDispatch } from "react-redux";


import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import { Link, useNavigate } from 'react-router-dom';

import { API } from "aws-amplify";

const useStyles = makeStyles({
    root: {
        '& .super-app-theme--header': {
            backgroundColor: config.main_color_1,
            fontSize: "16px",
            color: 'rgb(255,255,255)',
            fontFamily: "nunito"
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
    },
    ".MuiDataGrid-root": {
        fontSize: "14px",
        fontFamily: "nunito",
        fontWeight: 400,
        color: "black"
    }
});

// Data for Faculty Grid
const columns = [
    {
        field: 'Enrollment',
        headerName: 'Enrollment No',
        width: 300,
        flex: 1,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'Name',
        headerName: 'Name',
        width: 300,
        flex: 1,
        headerClassName: 'super-app-theme--header'
    },

    {
        field: 'Total',
        headerName: 'Total attendance',
        width: 300,
        flex: 1,
        headerClassName: 'super-app-theme--header'
    }
];

// Start of Faculty Grid Component
const AttendanceGrid = (props) => {
    let {userData, attendanceList, setAttendancelist, getAttendanceData, attendLoad, setAttendLoad, newBcid} = props;
    const [selectionModel, setSelectionModel] = useState([]);
    const [attendList, setAttendList] = useState([]);
    const [multigroups, setMultigroups] = useState(false);
    const [loading, setLoading] = useState(true);
    const [date, setDate] = useState(null)
    const classes = useStyles();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    let attendList1 = [];

    /* action: "get"
    bpid: userDetails.curprgcou.bpid
    oid: config.aws_org_id, */

    let userDetails = useSelector(authData);

    


    function postAttendanceDataCall() {
        if (
           
            date === null ||
            date === undefined || date == ''
        ) {
            swal({ type: "error", title: "Please select a date" });
        } else if (
            attendList.length === 0 ||
            attendList === undefined
        ) {
            swal({ type: "error", title: "Please select Students" });
        }
        else {
            postAttendanceData()
        }

    }


    async function postAttendanceData() {
        setLoading(true);
        const bodyParam = {
            body: {
                action: "update",
                bpid: userDetails.curprgcou.bpid,
                date: date,
                oid: config.aws_org_id,
                userlist: attendList,
                bcid: newBcid,
            },
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        };
        console.log(bodyParam.body);
        try {
            console.log(bodyParam.body);
            const response = await API.post(
                config.aws_cloud_logic_custom_name,
                `/attendance`,
                bodyParam
            );

            setSelectionModel([])
            setDate('');
            setAttendList([]);
            getAttendanceData(newBcid);
            console.log("response", response);


        }
        catch (error) {
            console.error(error);
        }
        setLoading(false);
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ display: "flex", justifyContent: "flex-end" }}>
                <GridToolbar />
            </GridToolbarContainer>
        );
    }

    const handleCellClick = (param, event) => {
        // console.log(param.row);
        // let sdata = { ...userDetails };
        // sdata.selbatchuser = { ...param.row };
        // dispatch(awsSignIn(sdata));

        // navigate("/userprogress");
        // console.log(event);
    }
    function checking(index1) {
        let rowObj = {};
        let attendList1 = [];
     
        console.log("batch", index1);
        for (let i = 0; i < index1.length; i++) {
            rowObj = attendanceList[index1[i]];
            attendList1.push(rowObj);
        }

        console.log("batch1", attendList1);
        setAttendList(attendList1)
    }



    /* let rowObj = attendanceList[index1];
          console.log("row",rowObj);
    
          if (attendList1.includes(rowObj)) {
            var index = attendList1.indexOf(rowObj);
            attendList1.splice(index, 1);
          } else {
            attendList1.push(rowObj);
          }
          console.log("batch", attendList1); */
    return (
        <div className={Assesg.maindiv}>

            <div className={Assesg.topbar}>
                <div className={Assesg.leftside}>
                    <h3 className={Assesg.select}>
                        Select Date
                    </h3>
                    <input style={{ paddingLeft: "5px", fontSize: "12px", border: "1px solid #e35f14", borderRadius: "5px" }} placeholder="Date" type="date" onChange={(e) => setDate(e.target.value)} value={date}></input>
                </div>
                <div className={Assesg.rightside}>
                    <button className={window.navigator.onLine === true ? Assesg.btn_color : Assesg.btn_colordis }
              disabled={!window.navigator.onLine} onClick={() => postAttendanceDataCall()}>Mark attendance</button>


                </div>
            </div>
            {attendLoad === false ?
                <div style={{ height: 500, width: '100%' }} className={classes.root}>
                    <DataGrid
                        rows={userData}
                        columns={columns}
                        checkboxSelection
                        disableSelectionOnClick
                        components={{ Toolbar: CustomToolbar }}
                        onRowSelected={e => console.log("e", e)}
                        onSelectionModelChange={(newSelection) => {
                            console.log("sel", newSelection);
                            setSelectionModel(newSelection);
                            checking(newSelection);
                        }}
                        selectionModel={selectionModel}
                        onCellClick={handleCellClick}
                        
                        className={classes['.MuiDataGrid-root']}
                    />
                </div>
                : <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", paddingTop: "20px", height: "100%" }}><Skeleton variant="rect" width="100%" height={400} /> </div>}
        </div>
    );
}

export default AttendanceGrid;